import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import { Button } from "@jti/core-components/components/Button";
import { SupportingText } from "@jti/core-components/components/SupportingText";
import { CopyButton } from "@jti/ui/components/CopyButton";
import { Typography } from "@jti/ui/components/Typography";

import styles from "./RedemptionConfirmation.module.scss";

const { sanitize } = dompurify;

export type RedemptionConfirmationProps = {
  externalCodeButtonLabel?: string;
  codeLabel: string;
  codeInfo: string;
  codes: string[];
  type: string;
};

export const RedemptionConfirmation: FC<RedemptionConfirmationProps> = ({
  externalCodeButtonLabel,
  codeLabel,
  codeInfo,
  codes,
  type,
}) => (
  <>
    <Typography variant="body2" weight="bold" className={styles.codeLabel}>
      {codeLabel}
    </Typography>
    {codes.map((code) =>
      type === "url" ? (
        <Button variant="primary" href={code} target="_blank" key={code} className={styles.button}>
          {externalCodeButtonLabel ?? ""}
        </Button>
      ) : (
        <div className={styles.code} data-testid="redeemDialogCode" key={code}>
          {code}
          <CopyButton text={code} />
        </div>
      )
    )}
    <div className={styles.info}>
      <SupportingText>
        <span dangerouslySetInnerHTML={{ __html: sanitize(codeInfo) }} />
      </SupportingText>
    </div>
  </>
);
